import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, AlertTriangle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center max-w-md px-4">
        <div className="inline-flex items-center justify-center h-20 w-20 rounded-2xl gradient-primary mb-6">
          <AlertTriangle className="h-8 w-8 text-foreground" />
        </div>
        <h1 className="mb-2 text-6xl font-bold gradient-text">404</h1>
        <p className="mb-2 text-xl font-semibold text-foreground">Page not found</p>
        <p className="mb-8 text-sm text-muted-foreground">
          The page <span className="font-mono text-primary">{location.pathname}</span> doesn't exist or has been moved.
        </p>
        <Button
          onClick={() => navigate('/dashboard')}
          className="bg-[#111111] text-white hover:bg-[#333333] font-semibold gap-2"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
